import React, { useEffect, useState } from 'react';
import styles from './NotificationCompleted.module.css';

const NotificationCompleted = ({ message, onClose, visible, time = 5 }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, time * 1000);
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className={`${styles.notification} ${isMobile ? styles.mobile : styles.desktop}`}>
      <div className={styles.notificationContent}>
        <span>{message}</span>
        <button className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
          &times;
        </button>
      </div>
    </div>
  );
};

export default NotificationCompleted;